import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './index.css'

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((registration) => {
        // Service Worker registrado exitosamente
        // Verificar actualizaciones periódicamente
        setInterval(() => {
          registration.update()
        }, 60000) // Cada minuto
      })
      .catch((error) => {
        // Error al registrar Service Worker - solo en desarrollo
        if (import.meta.env.DEV) {
          console.error('Error al registrar Service Worker:', error)
        }
      })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 2500,
          style: {
            background: '#363636',
            color: '#fff',
            borderRadius: '12px',
            padding: '12px 16px',
            fontSize: '14px',
            maxWidth: '90vw',
          },
          success: {
            duration: 2000,
            style: {
              background: '#22c55e',
              borderRadius: '12px',
              padding: '12px 16px',
              fontSize: '14px',
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#22c55e',
            },
          },
          error: {
            duration: 3000,
            style: {
              background: '#ef4444',
              borderRadius: '12px',
              padding: '12px 16px',
              fontSize: '14px',
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#ef4444',
            },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)
